import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

export const transformReviewListResponse = data =>
  data.map(review => {
    const { ratingId, ...restReview } = review;
    return {
      id: ratingId,
      ...restReview,
    };
  });

const handler = ({ httpClient }, venueId, requestedPage, filters, previousReviewsData = []) => {
  const endpoint = URLS.ratings.reviewsList(venueId, requestedPage, filters);

  return httpClient
    .get(endpoint)
    .then(transformKeysToCamelCase)
    .then(
      ({
        data: {
          reviews,
          meta: { currentPage, numPages },
        },
      }) => ({
        reviews: [...previousReviewsData, ...transformReviewListResponse(reviews)],
        // Page numbers are starting from 0
        hasMore: currentPage !== numPages - 1,
        currentPage,
      })
    );
};

export default makeEntityScaffold('SAGA.API.FETCH_REVIEWS', handler, {
  defaultKey: (_, venueId, requestedPage, filters) => {
    return `${venueId}_${requestedPage}_${JSON.stringify(filters)}`;
  },
});
